import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt, faExclamationTriangle, faWater, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons'

import RowDisplay from '../components/farm/field/rowdisplay.js'
import Box from '../components/ui/Box.js';
import Loadable from '../components/ui/loading/Loadable.js';
import FieldForm from '../components/farm/field/form.js';
import ConfirmUI from '../components/ui/Confirm.js';
import LeaseHistory from '../components/farm/field/leasehistory.js';
import ShowIff from '../components/ui/ShowIff.js';
//import HarvestChart from '../components/charts/HarvestChart.js';
import CostsChartGroup from '../components/charts/CostsChartGroup.js';

import api from '../api/index.js';


class Page extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rows: false,
			redirect: false,
			owner: false,
			former: false,
			leaseHistory: false,
			editRowFormOpen: false,
			editFieldFormOpen: false,
			farmName: ''
		};
		
		// Child interfaces (rows, harvests, something else?)
		this.onAddRowSubmit = this.onAddRowSubmit.bind(this);
		this.editRowFormOpen = this.editRowFormOpen.bind(this);
		this.editRowFormClose = this.editRowFormClose.bind(this);
		this.editFieldFormOpen = this.editFieldFormOpen.bind(this);
		this.editFieldFormClose = this.editFieldFormClose.bind(this);
		
		// Field actions
		this.fieldUpdated = this.fieldUpdated.bind(this);
		this.discontinueFieldClick = this.discontinueFieldClick.bind(this);
		this.discontinueField = this.discontinueField.bind(this);
		this.deleteFieldClick = this.deleteFieldClick.bind(this);
		this.deleteField = this.deleteField.bind(this);
		this.replantFieldClick = this.replantFieldClick.bind(this);
	
		this.refreshRows = this.refreshRows.bind(this);
	}

	async refreshRows() {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id + '/fields/' + this.props.match.params.field_id + '/rows?from=' + this.props.dateStart.api() + '&until=' + this.props.dateEnd.api());
			this.setState({rows: data});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	async refreshOwner() {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id + '/fields/' + this.props.match.params.field_id + '?from=' + this.props.dateStart.api() + '&until=' + this.props.dateEnd.api());
			data[0]['discontinued'] = api.isCurrentlyDisabled(data[0].DiscontinuedDate);
			this.setState({owner: data[0]}, this.refreshFormer);
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	refreshFormer = async () => {
		if (this.state.owner.PreviousID == null)
			return;
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id + '/fields/' + this.state.owner.PreviousID + '?from=' + this.props.dateStart.api() + '&until=' + this.props.dateEnd.api());
			this.setState({former: data[0]});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
		
	
	
	refreshLeaseHistory = async () => {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id + '/fields/' + this.props.match.params.field_id + '/leasehistory');
			this.setState({leaseHistory: data});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	async onAddRowSubmit(e) {
		this.refreshRows();
		return true;
	}
	
	
	
	editRowFormClose() { this.setState({editRowFormOpen: false}); }
	editRowFormOpen() {	this.setState({editRowFormOpen: true}); }
	
	editFieldFormClose() { this.setState({editFieldFormOpen: false}); }
	editFieldFormOpen() {	this.setState({editFieldFormOpen: "edit"}); }
	
	discontinueFieldClick() {
		confirmAlert({
			title: 'Discontinue this field: '  + this.state.owner.FieldNumber,
			customUI: ConfirmUI(
				this.discontinueField, 
				<div><p>This will remove the farm from your lists, but it'll be preserved in historical data.  It is the safest way to be rid of a farm.</p><p><em>Are you sure to discontinue this farm?</em></p></div>
			),
		});

	}
	
	async discontinueField() {
		try {
			await api.get('farms/' + this.props.match.params.farm_id + '/fields/' + this.props.match.params.field_id + '/discontinue');
			this.setState({redirect: '/farm/' + this.props.match.params.farm_id});
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	deleteFieldClick() {
		confirmAlert({
			title: 'Discontinue this field: '  + this.state.owner.FieldNumber,
			customUI: ConfirmUI(
				this.deleteField, 
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a field by mistake. Are you sure you want to do this?</p></div>
			),
		});

	}
	
	
	replantFieldClick() {
		console.log("Opening replant form");
		this.setState({editFieldFormOpen: "replant"});
	}
	

	async deleteField() {
		try {
			await api.del('farms/' + this.props.match.params.farm_id  + '/fields/' + this.props.match.params.field_id);
			this.setState({redirect: '/farm/' + this.props.match.params.farm_id});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	
	
	
	fieldUpdated(id) {
		this.refreshOwner();
		this.editFieldFormClose();
	}
	
	replantField = (id) => {
		console.log("Field replanted, attempting to redirect");
		window.location = '/farm/' + this.props.match.params.farm_id + '/field/' + id;
		//this.setState({redirect: '/farm/' + this.props.match.params.farm_id + '/field/' + id});
	}
	
	async getFarmname() {
		try {
			let data = await api.get('farms/' + this.props.match.params.farm_id);
			this.setState({farmName: data[0].FarmName});
		} catch(e) {
			api.handleExceptions(e);
		};
	}
	componentDidMount() {
		this.getFarmname();
		this.refreshRows();
		this.refreshOwner();
		this.refreshLeaseHistory();

	}

	componentDidUpdate(priorProps) {
		if (priorProps.dateStart !== this.props.dateStart || priorProps.dateEnd !== this.props.dateEnd || this.props.match.params.field_id !== priorProps.match.params.field_id) {
			this.getFarmname();
			this.refreshRows();
			this.refreshOwner();
			this.refreshLeaseHistory();
		}
	}


	// <HarvestChart dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} farm={this.props.match.params.farm_id} field={this.props.match.params.field_id} />


	render() {
		if (this.state.redirect)
			return  <Redirect to={this.state.redirect} />
		
		var fo = {...this.state.owner};
		// Default the start date to TODAY, in the replant form
		if (this.state.editFieldFormOpen === "replant") {
			fo['StartDate'] = new Date();
		}

		return <div className="Field Specific">
					<p><Link to={"/farm/" + this.props.match.params.farm_id}>
						<FontAwesomeIcon icon={faArrowAltCircleLeft} className="backwardIcon" /> Back to <strong>{this.state.farmName} ranch</strong>
					</Link></p>
					<LeaseHistory data={this.state.leaseHistory} endDate={this.props.dateEnd.api()} />
				<Box 
					title={this.state.editFieldFormOpen === "edit" ? "Modify the field information" : "Replant this field"} 
					modal={true} 
					isOpen={this.state.editFieldFormOpen !== false} 
					onRequestClose={this.editFieldFormClose}
				>
					<FieldForm {...fo} 
						mode={this.state.editFieldFormOpen}
						onUpdated={this.state.editFieldFormOpen === "edit" ? this.fieldUpdated : this.replantField} 
					/>
				</Box>
				<Box title={this.state.farmName + ' – ' + this.state.owner.FieldNumber} modalTitle="Field actions" options={[
					{
						label: <span><FontAwesomeIcon icon={faEdit} className="editIcon" /> Edit this field's info</span>,
						callback: this.editFieldFormOpen,
						separator: this.state.owner.discontinued
					},
					this.state.owner.discontinued ? false : {
						label: <span><FontAwesomeIcon icon={faWater} className="plantIcon" /> Replant this field</span>,
						callback: this.replantFieldClick,
						separator: true
					},
					this.state.owner.discontinued ? false : {
						label: <span><FontAwesomeIcon icon={faTrashAlt} className="deleteIcon" /> Discontinue this field</span>,
						callback: this.discontinueFieldClick,
						separator: true
					},
					{
						label: <span><FontAwesomeIcon icon={faExclamationTriangle} className="exclaimIcon" /> <small>Actually <strong>delete</strong> this field from the system</small></span>,
						callback: this.deleteFieldClick
					},
				]}>
					<ShowIff iff={this.state.former !== false}>
						<p className="replanted">Formerly
							<a href={"/farm/" + this.props.match.params.farm_id + "/field/" + this.state.former.FieldID}> {this.state.former.FieldNumber}
							</a>
						</p>
					</ShowIff>
					<div className="widget-holder">
						<CostsChartGroup dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} farm={this.props.match.params.farm_id} field={this.props.match.params.field_id} />
					</div>
				</Box>
				<Loadable ready={this.state.owner && this.state.rows}>
					<RowDisplay field={this.state.owner} rows={this.state.rows} onChange={this.refreshRows} />
				</Loadable>
				
			</div>;
	}
}

export default Page;